import React, {Component} from 'react';
import cx from 'classnames';

export default class ContentThumbnail extends Component {
    constructor(){
        super();
        this.displayVideo = this.displayVideo.bind(this);
    }

    displayVideo(){
        const {contentFormat, videoContentPath} = this.props;

        return contentFormat === 'video' ? (
            <video
                className='show hide@xs'
                src={videoContentPath}
                autoPlay={true}
                loop={true}
                muted={true} />
        ) : null;
    }

    render(){
        const {type, caption, contentPath, displayStatic} = this.props;
        const video = this.displayVideo();
        const thumbnailCaptionClassNames = cx('content-thumbnail-caption', `${type.toLowerCase().split(' ').join('-')}-caption`);
        const thumbnailDescriptionClassNames = cx('caption-description', {'caption-description-web-static': displayStatic});
        const style = {
            backgroundImage: `url(${contentPath})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        };

        return(
            <div className='content-thumbnail'>
                <div className='content-thumbnail-filter'></div>
                <div className='content-thumbnail-media' style={style}>
                    {video}
                </div>
                <div className={thumbnailCaptionClassNames}>
                    <h2 className='caption-type'>{type}</h2>
                    <div className='caption-blue-line-divider'></div>
                    <h3 className={thumbnailDescriptionClassNames}>{caption}</h3>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/endless_possibilities/content_thumbnail.js